module.exports = __webpack_public_path__ + "assets/aca0e4d1cfaca14e195d0c15ff1ad84a.mp3";